module.exports = __webpack_public_path__ + "2c0054e3fb4d0879930a094000d5aa8c.png";